<template>
    <modal :title="setModel!=undefined?'Update Currency':'Add Currency'" @close="$emit('close')">
        <template #content>
            <Form method="dialog" @submit="onSubmit" v-slot="{ errors }" class="floating-labels p-1rem" ref="form">
                <formGroup v-if="setModel==undefined" :title="'Code'" v-model="model.Code" :errors="errors" :rules="{required:true}" @keydown.enter="save"></formGroup>
                <formGroup :title="'Name'" v-model="model.Name" :errors="errors" :rules="{required:true}" @keydown.enter="save"></formGroup>
                <formGroup :title="'Minor'" :type="'number'" v-model.number="model.Minor" :errors="errors" :rules="{required:true}" @keydown.enter="save"></formGroup>
            </Form>
        </template>
        <template #foot>
            <Btn class="btn-success btn-md" @click="save" :process="process">{{setModel!=undefined?'Update Currency':'Add Currency'}}</Btn>
        </template>
    </modal>
</template>

<script>
    export default {
        props:{
            setModel:Object
        },
        data(){
            return{
                model:{
                    Code:"",
                    Name:"",
                    Minor:""
                },
                errs:{

                },
                process:false
            }
        },
        created(){
            if(this.setModel!=undefined){
                this.model={...this.setModel};
            }
        },
        methods:{
            save(){
                this.$refs.form.validate().then(valid =>{
                    if(valid.valid){
                        this.process=true;
                        this.$appAxiosAdmin.put(`Currencies`,this.model).then(response => {
                            this.process=false;
                            this.$swal({
                                icon:"success",
                                title:"Success",
                                text:this.setModel!=undefined?"The currency has been successfully updated.":"The currency has been successfully added.",
                                timer: 2000,
                                confirmButtonText:"Okey"
                            });
                            if(this.setModel!=undefined){
                                this.$emit("update",response.data);
                            }else{
                                this.$emit("add",response.data);
                            }
                            this.$emit("close");
                        }).catch(err=>{
                            this.process=false;
                    this.$isError(err);
                        });
                    }
                });
            }
        }
    }
</script>

<style>

</style>